const defaultColor = 'blue';
const colorList = ['green', 'blue', 'yellow', 'red'];
const colorConfig = {
    'background': {
        'gradient': 'gradient-gray',
        'background': 'bg-neutral-700',
    },
    'blue': {
        'text': 'text-sky-300',
        'gradient': 'gradient-blue',
        'background': 'bg-sky-700',
        'border': 'border-sky-400',
        'gradient-end': 'to-sky-400',
    },
    'yellow': {
        'text': 'text-amber-300',
        'gradient': 'gradient-yellow',
        'background': 'bg-amber-500',
        'border': 'border-amber-500',
        'gradient-end': 'to-amber-500',
    },
    'green': {
        'text': 'text-lime-300',
        'gradient': 'gradient-green',
        'background': 'bg-lime-600',
        'border': 'border-lime-600',
        'gradient-end': 'to-lime-600',
    },
    'red': {
        'text': 'text-red-300',
        'gradient': 'gradient-red',
        'background': 'bg-red-700',
        'border': 'border-red-700',
        'gradient-end': 'to-red-600',
    },
}

export const getColorConfig = (key) => {
    let _key = null;
    if (key && colorConfig.hasOwnProperty(key)) _key = key;
    return _key ? colorConfig[_key] : null;
};

export const getColorByIndex = (index) => {
    return colorList[index % colorList.length];
};

export const getColorConfigByIndex = (index, type) => {
    return colorConfig[getColorByIndex(index)][type];
};